module.exports = __webpack_public_path__ + "media/assets/images/sunny_sometime_will_cloudy-a13acbcb34b30aa74fd671c3f14b69cc.png";